import axios from 'axios';

export default {
    list() {
        return axios.get(window.applicationSettings.apiEndpoint + '/risk/year/list')
            .then(response => response.data)
            .catch(error => Promise.reject(error.response));
    },
    fetch(yearId) {
        return axios.get(window.applicationSettings.apiEndpoint + '/risk/year/fetch/' + yearId)
            .then(response => response.data)
            .catch(error => error.response);
    },
    create(payload) {
        var formData = new FormData();
        formData.append('data', JSON.stringify(payload));
        return axios.post(window.applicationSettings.apiEndpoint + '/risk/year/create', formData)
            .then(response => response.data)
            .catch(error => error.response);
    },
    update(yearId, payload) {
        var formData = new FormData();
        formData.append('data', JSON.stringify(payload));
        return axios.post(window.applicationSettings.apiEndpoint + '/risk/year/update/' + yearId, formData)
            .then(response => response.data)
            .catch(error => Promise.reject(error.response));
    },
    delete(yearId) {
        return axios.delete(window.applicationSettings.apiEndpoint + '/risk/year/delete/' + yearId)
            .then(response => response.data)
            .catch(error => Promise.reject(error.response));
    }
}